import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import FeedbackPage from './pages/FeedbackPage';
import BetaTesterPage from './pages/BetaTesterPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import VerificationSuccess from './pages/VerificationSuccess';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/support" element={<FeedbackPage />} />
          <Route path="/beta" element={<BetaTesterPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/verified" element={<VerificationSuccess />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
